// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"783":"booking-form","878":"recruiter","884":"admin","945":"dashboard"}[chunkId] || chunkId) + "." + {"453":"32b97b7c","659":"8e725273","783":"157fcb96","878":"bd9320ae","884":"05144eac","915":"8c3011ee","945":"2858e08b"}[chunkId] + ".chunk.js";
};